import { Injectable } from '@angular/core';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { ModalConfig } from '../models/modalConfig';
import { AngularModalService } from './modal.service';
import { CompanyPageDisassociateVendorsModalComponent } from 'src/app/pages/mission-control-page/company-page/company-page-disassociate-vendors-modal/company-page-disassociate-vendors-modal.component';

// Downgraded (see service.module.ajs.js) so the still-AngularJS
// company-page.component.js root controller (native port not due until
// build step 10) can open this native modal in place of its old
// `this.$uibModal.open({component: 'disassociateVendorsModal', ...})` call.
@Injectable({
  providedIn: 'root'
})
export class CompanyPageDisassociateVendorsModalService {

  disassociateVendorsModal!: BsModalRef;

  constructor(private bsModalService: BsModalService, private angularModalService: AngularModalService) { }

  show(initialState: { buVendorsInfo: any }, onResult: (callbackObject: any) => void): void {
    const config = new ModalConfig();
    config.class = 'four-dot-five-modal-medium';
    config.ignoreBackdropClick = true;
    config.initialState = initialState;
    this.disassociateVendorsModal = this.bsModalService.show(CompanyPageDisassociateVendorsModalComponent, config);
    this.disassociateVendorsModal.content.onClose.subscribe((callbackObject: any) => {
      this.angularModalService.addModalOpenClassToBodyIfAnyModalIsOpen();
      onResult(callbackObject);
    });
  }
}
